import { BasicResult } from '../basic-result';
import { AuditLocation } from './audit-location';

export class NewLocationWizardResult extends BasicResult {
  LocationID: number = -1;
  Location: AuditLocation = new AuditLocation();

  constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
    if (values.hasOwnProperty('Location')) {
      this.Location = new AuditLocation((values as NewLocationWizardResult).Location);
    }
  }
}
